import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      try {
        console.log("Modal opening...");
        form.resetFields();
        setVisible(true);
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));
  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        roleName: values.roleName,
        remark: values.remark,
        createBy: localStorage.getItem("accountId"),
      };
      console.log(queryParams);
      const response = await http.post(`${api.getRoleAdd}`, queryParams);
      if (response.code === "1") {
        message.success("Add role successfully");
        setVisible(false);
        form.resetFields();
         onSuccess?.();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error("Submit an error and try again later.");
    } finally {
      setLoading(false);
    }
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              ADD ROLE
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        footer={
            <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>}
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="passwordResetForm"
                onFinish={onFinishAdd}
                form={form}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
                <Form.Item
                  name="roleName"
                  label="Role Name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Role Name.",
                    },
                  ]}
                >
                  <Input placeholder="Please enter Role Name." allowClear />
                </Form.Item>

                <Form.Item name="remark" label="Remark">
                  <Input placeholder="Please enter remark." allowClear />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
  );
});

export default AddModal;
